<select-from-tree
	class=""
	[ngModel]="selection?.name"
	[hierarchyList]="options"
	(onNodeClick)="selectOption($event.node)">
</select-from-tree>
